const PC_BREAKPOINT = 1280;
const COLLAPSED_KEY = 'bishoku_search_collapsed';

function labelOf(input: HTMLInputElement): string {
  return input.dataset.label || input.value;
}

function updateAreaValue(form: HTMLElement): void {
  const checked = Array.from(
    form.querySelectorAll<HTMLInputElement>('input[name="area[]"]:checked')
  ).map(labelOf).filter(Boolean);
  const el = form.querySelector<HTMLElement>('.condition.area .value');
  if (el) el.textContent = checked.length ? checked.join('・') : '全国から';
}

function updateGenreValue(form: HTMLElement): void {
  const checked = Array.from(
    form.querySelectorAll<HTMLInputElement>('input[name="genre[]"]:checked')
  ).map(labelOf).filter(Boolean);
  const el = form.querySelector<HTMLElement>('.condition.genre .value');
  if (el) el.textContent = checked.length ? checked.join('・') : 'ジャンル指定なし';
}

function updateSummary(form: HTMLElement): void {
  const el = form.querySelector<HTMLElement>('.parameters .summary');
  if (!el) return;

  const add = (className: string, text: string) => {
    const div = document.createElement('div');
    div.className = className;
    div.textContent = text;
    el.appendChild(div);
  };

  el.innerHTML = '';

  const areas = Array.from(form.querySelectorAll<HTMLInputElement>('input[name="area[]"]:checked'))
    .map(labelOf).filter(Boolean);
  add('area', areas.length ? areas.join('、') : '指定なし');

  const genres = Array.from(form.querySelectorAll<HTMLInputElement>('input[name="genre[]"]:checked'))
    .map(labelOf).filter(Boolean);
  add('genre', genres.length ? genres.join('、') : '指定なし');

  const lunch = form.querySelector<HTMLSelectElement>('select[name="lunch"]');
  add('lunch', lunch?.value ? lunch.options[lunch.selectedIndex].text : '指定なし');

  const dinner = form.querySelector<HTMLSelectElement>('select[name="dinner"]');
  add('dinner', dinner?.value ? dinner.options[dinner.selectedIndex].text : '指定なし');

  const keyword = (form.querySelector<HTMLInputElement>('input[name="keyword"]')?.value ?? '').trim();
  add('keyword', keyword ? `「${keyword}」` : '指定なし');
}

function animateHeight(el: HTMLElement, from: number, to: number): void {
  el.style.overflow = 'hidden';
  el.style.height = from + 'px';
  requestAnimationFrame(() => {
    el.style.height = to + 'px';
    const onEnd = (e: TransitionEvent) => {
      if (e.propertyName !== 'height') return;
      el.style.height = '';
      el.style.overflow = '';
      el.removeEventListener('transitionend', onEnd);
    };
    el.addEventListener('transitionend', onEnd);
  });
}

function updateAreaAllCheckbox(category: HTMLElement): void {
  const toggle = category.querySelector<HTMLInputElement>('.js-area-all');
  if (!toggle) return;
  const children = Array.from(category.querySelectorAll<HTMLInputElement>('input[name="area[]"]'));
  if (children.length === 0) return;
  const checkedCount = children.filter(c => c.checked).length;
  if (checkedCount === 0) {
    toggle.checked = false;
    toggle.indeterminate = false;
  } else if (checkedCount === children.length) {
    toggle.checked = true;
    toggle.indeterminate = false;
  } else {
    toggle.checked = false;
    toggle.indeterminate = true;
  }
}

function syncAreaCategory(condition: HTMLElement, value: string): void {
  condition.querySelectorAll<HTMLElement>('.options .category').forEach(cat => {
    cat.classList.toggle('js-open', cat.dataset.category === value);
  });
}

function openDialog(condition: HTMLElement): void {
  condition.classList.add('is-open');
  document.body.style.overflow = 'hidden';

  // SP エリアダイアログ：現在の js-open カテゴリーを select に反映
  const sel = condition.querySelector<HTMLSelectElement>('.sp-dialog-category-select select');
  if (sel) {
    const open = condition.querySelector<HTMLElement>('.options .category.js-open');
    if (open?.dataset.category) sel.value = open.dataset.category;
  }
}

function closeDialog(condition: HTMLElement, form: HTMLElement): void {
  condition.classList.remove('is-open');
  document.body.style.overflow = '';
  if (condition.classList.contains('area')) updateAreaValue(form);
  if (condition.classList.contains('genre')) updateGenreValue(form);
}

export function initSearchRestaurant(): void {
  document.querySelectorAll<HTMLElement>('.search-restaurant').forEach(section => {
    const form = section.querySelector<HTMLElement>('form');
    if (!form) return;

    // PC: エリアカテゴリータブの切り替え
    form.querySelectorAll<HTMLInputElement>('.condition.area .head input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', () => {
        const condition = radio.closest<HTMLElement>('.condition.area');
        if (condition) syncAreaCategory(condition, radio.value);
      });
    });

    // SP: エリアカテゴリーセレクトボックスの切り替え
    form.querySelectorAll<HTMLSelectElement>('.condition.area .sp-dialog-category-select select').forEach(sel => {
      sel.addEventListener('change', () => {
        const condition = sel.closest<HTMLElement>('.condition.area');
        if (condition) syncAreaCategory(condition, sel.value);
      });
    });

    // SP: ダイアログを開く
    form.querySelectorAll<HTMLElement>('.condition .button button').forEach(btn => {
      btn.addEventListener('click', () => {
        const condition = btn.closest<HTMLElement>('.condition');
        if (condition && window.innerWidth < PC_BREAKPOINT) openDialog(condition);
      });
    });

    // SP: オーバーレイ（.options 背景）タップで閉じる
    form.querySelectorAll<HTMLElement>('.condition .options').forEach(overlay => {
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) {
          const condition = overlay.closest<HTMLElement>('.condition');
          if (condition) closeDialog(condition, form);
        }
      });
    });

    // SP: 決定する（閉じる＋表示テキスト更新）
    form.querySelectorAll<HTMLElement>('.sp-dialog-close, .sp-dialog-apply').forEach(btn => {
      btn.addEventListener('click', () => {
        const condition = btn.closest<HTMLElement>('.condition');
        if (condition) closeDialog(condition, form);
      });
    });

    // SP: 閉じる（表示テキスト更新なし）
    form.querySelectorAll<HTMLElement>('.sp-dialog-cancel').forEach(btn => {
      btn.addEventListener('click', () => {
        const condition = btn.closest<HTMLElement>('.condition');
        if (!condition) return;
        condition.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });

    // チェックボックス変更
    form.addEventListener('change', (e) => {
      const target = e.target as HTMLInputElement;
      const isPc = window.innerWidth >= PC_BREAKPOINT;

      // "すべて" トグル
      if (target.classList.contains('js-area-all')) {
        const category = target.closest<HTMLElement>('.category');
        if (category) {
          category.querySelectorAll<HTMLInputElement>('input[name="area[]"]').forEach(cb => {
            cb.checked = target.checked;
          });
          target.indeterminate = false;
        }
        if (isPc) updateAreaValue(form);
        return;
      }

      if (!isPc) return;
      if (target.name === 'area[]') {
        const category = target.closest<HTMLElement>('.category');
        if (category) updateAreaAllCheckbox(category);
        updateAreaValue(form);
      }
      if (target.name === 'genre[]') updateGenreValue(form);
    });

    // .parameters 折りたたみトグル
    form.querySelectorAll<HTMLElement>('.parameters .shrink').forEach(shrink => {
      shrink.addEventListener('click', () => {
        const params = shrink.closest<HTMLElement>('.parameters');
        if (!params) return;
        const inner = params.querySelector<HTMLElement>('.parameters-inner');
        if (!inner) return;

        if (params.classList.contains('is-collapsed')) {
          // 展開：ユーザーが意図的に開いた → 保存状態をクリア
          sessionStorage.removeItem(COLLAPSED_KEY);
          const from = inner.scrollHeight;
          params.classList.remove('is-collapsed');
          const to = inner.scrollHeight;
          animateHeight(inner, from, to);
        } else {
          // 折りたたむ：ユーザーが意図的に閉じた → 保存
          sessionStorage.setItem(COLLAPSED_KEY, '1');
          const from = inner.scrollHeight;
          updateSummary(form);
          params.classList.add('is-collapsed');
          const to = inner.scrollHeight;
          animateHeight(inner, from, to);
        }
      });
    });

    // 検索条件クリア（初期値ではなく空状態にする）
    section.querySelectorAll<HTMLElement>('.reset').forEach(btn => {
      btn.addEventListener('click', () => {
        form.querySelectorAll<HTMLInputElement>('input[name="area[]"], input[name="genre[]"]').forEach(cb => {
          cb.checked = false;
        });
        form.querySelectorAll<HTMLSelectElement>('select[name="lunch"], select[name="dinner"]').forEach(sel => {
          sel.value = '';
        });
        const keyword = form.querySelector<HTMLInputElement>('input[name="keyword"]');
        if (keyword) keyword.value = '';
        form.querySelectorAll<HTMLElement>('.options .category').forEach(cat => updateAreaAllCheckbox(cat));
        updateAreaValue(form);
        updateGenreValue(form);
        const areaCond = form.querySelector<HTMLElement>('.condition.area');
        if (areaCond) syncAreaCategory(areaCond, 'tokyo');
        form.querySelector<HTMLElement>('.parameters')?.classList.remove('is-collapsed');
      });
    });

    // URL パラメーター反映時の初期状態を同期
    form.querySelectorAll<HTMLElement>('.options .category').forEach(cat => updateAreaAllCheckbox(cat));
    updateAreaValue(form);
    updateGenreValue(form);
    // 簡易表示初期化：サーバー側で collapsed、またはユーザーが閉じた状態を保存済みの場合に適用
    const params = form.querySelector<HTMLElement>('.parameters');
    if (params) {
      if (!params.classList.contains('is-collapsed') && sessionStorage.getItem(COLLAPSED_KEY) === '1') {
        params.classList.add('is-collapsed');
      }
      if (params.classList.contains('is-collapsed')) updateSummary(form);
    }
  });
}
